import gql from 'graphql-tag'

export const searchObjects = gql`
  query SearchObjects(
    $entityId: Int!
    $token: String
    $offset: Int
    $filterValues: String
    $fieldMatch: String
    $search: String
    $fieldFilters: String
    $sort: String
    $userId: Int
  ) {
    searchObjects(
      entityId: $entityId
      token: $token
      offset: $offset
      filterValues: $filterValues
      fieldMatch: $fieldMatch
      search: $search
      fieldFilters: $fieldFilters
      sort: $sort
      userId: $userId
    ) {
      total
      page
      objects
    }
  }
`
